import { ReadingTestExamples } from "./ReadingTestExamples";


export const ReadingTestQuestion = ({test, type, testIndex,  answers1, answers2})=>{
    let question = test.testList[testIndex].questions[test.questionIndex];
    if( undefined===question )return;
    
    
    let sectionCount = 5;
    let sectionAnswerCount = null;
    let currentAnswerIndex = null;
        

    if( (type===3 && testIndex===0) || type===1 ){
        //첫번째
        sectionCount = 10;
        currentAnswerIndex = test.questionIndex;
        sectionAnswerCount = answers1.length;
        if(test.questionIndex>=22){
            //세번째
            sectionCount = 8;
            currentAnswerIndex = test.questionIndex - 22;
            sectionAnswerCount = answers1.length - 22;
        }else if(test.questionIndex>=10){
            //두번째
            sectionCount = 12;
            currentAnswerIndex = test.questionIndex - 10;
            sectionAnswerCount = answers1.length - 10;
        }
    }else{
        sectionAnswerCount = answers2.length%sectionCount;
        currentAnswerIndex = test.questionIndex%sectionCount;
    }
    
    // 세부 그룹내의 질문 번호 목록 및 이전번호 현재 번호 표시
    const sectionNumbers = [...Array(sectionCount)].map((i, key) =>{
        let activeClass = '';
        if(key===currentAnswerIndex){
            activeClass = 'current';
        }else if(key<sectionAnswerCount){
            activeClass = 'active';
        }
        return (
            <span className={activeClass} key={key}>{key+1}</span>
        );
    });

    // 질문앞에 세부 그룹내의 질문 번호
    let questionNumber = 0;
    if( testIndex===0 ){
        questionNumber = test.questionIndex;
        if(questionNumber>=22){
            questionNumber = questionNumber - 22;
        }else if(questionNumber>=10){
            questionNumber = questionNumber - 10;
        }
    }else{
        questionNumber = questionNumber%5;
    }

    return (
        <div className="section pdT0">
            <div className="question_area">
                <div className="cont_inner">
                    <div className="question_nav">
                        {sectionNumbers}
                    </div>

                    <div className="question">
                        <p className="text">
                            <span className="num"> {questionNumber+1}</span>
                            <span dangerouslySetInnerHTML={{__html:question.question}}></span>
                        </p>
                        {(question.quotation!=='') && <div className="quotation" dangerouslySetInnerHTML={{__html:question.quotation}}></div>}
                        {(question.image!=='') && 
                        <div className="image">
                            <img src={`${process.env.PUBLIC_URL}${question.image}`} alt={question.question} />
                        </div>}
                    </div>
                    <div className="examples">
                        <ul>
                            <ReadingTestExamples examples={question.examples} />
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
};


